import { useT } from "@hooks";
import type { MaintenanceAlertSeverity } from "@services/maintenance";

export type AlertSeverityColor = "danger" | "warning" | "primary";

interface AlertSeverityMeta {
  labelKey: string;
  color: AlertSeverityColor;
  icon: string;
}

export const SEVERITY_META: Record<MaintenanceAlertSeverity, AlertSeverityMeta> = {
  CRITICAL: { labelKey: "maintenance.alerts.severity.critical", color: "danger", icon: "rioglyph-warning-sign" },
  WARNING: { labelKey: "maintenance.alerts.severity.warning", color: "warning", icon: "rioglyph-warning-sign" },
  INFO: { labelKey: "maintenance.alerts.severity.info", color: "primary", icon: "rioglyph-info-sign" },
};

interface AlertSeverityChipProps {
  severity: MaintenanceAlertSeverity;
  className?: string;
}

export const AlertSeverityChip = ({ severity, className = "" }: Readonly<AlertSeverityChipProps>) => {
  const t = useT();
  const meta = SEVERITY_META[severity];
  return (
    <span
      className={`display-inline-block padding-x-15 padding-y-2 rounded-circle border border-width-1 text-size-12 text-medium white-space-nowrap border-color-${meta.color} text-color-${meta.color} ${className}`.trim()}
    >
      {t(meta.labelKey)}
    </span>
  );
};
